module.exports = __webpack_public_path__ + "img/ecom-wildberries.ff62c083.png";